import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DeletePreviewResponse } from '../../services/api-services/admin-images.service';

@Component({
  selector: 'app-delete-preview-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './delete-preview-modal.component.html',
  styleUrl: './delete-preview-modal.component.scss'
})
export class DeletePreviewModalComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<DeletePreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeletePreviewResponse
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
